module.exports = __webpack_public_path__ + "static/media/31_tn.6f51e5aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/31_tn.jpg
// module id = 667
// module chunks = 0